export enum PaymentStatusEnum {
  NOTDEFINED = 0,
  INACTIVE = 1,
  ACTIVE = 2,
  CANCELLED = 3,
  EXPIRED = 4,
  SUBMITED = 5,
  SETTLED = 6,
  ERROR = 7,
  REFUNDED = 8,
  PENDING_INVOICE = 9,
  PENDING = 10,
  VIEWED = 11
}
